import React, { useEffect, useMemo, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Tag } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ExpenseTable from "../vendorDetail/expenseTable";
import { useToasts } from "react-toast-notifications";
import CustomDropdown from "../vendorDetail/vendorLedger/customDateRenge";
import { fetchAsyncTransactionDetails } from "redux/embrillProfileSlice";
import { formatAmountIndianRupees } from "jsFunctions/formatAmountInINR";
import { Form } from "react-bootstrap";
import { dateFormatWithTime } from "jsFunctions/dateTime.js";
import { formatDate } from "jsFunctions/dateTime";
import { getFirstDayOfMonth } from "jsFunctions/dateTime";
import { getLastDayOfMonth } from "jsFunctions/dateTime";
import { financialYearOptions } from "jsFunctions/dateTime";
import { useParams } from "react-router-dom";
import { fetchAsyncVendorTransactions } from "redux/vendorSlice";


const statementColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "PoNo",
    accessor: "poNo",
  },
  {
    Header: "Payment Id",
    accessor: "paymentId",
  },
  
  {
    Header: "Request Id",
    accessor: "requestId",
  },
  {
    Header: "UTR No",
    accessor: "utrNo",
  },
  {
    Header: "Unique Id",
    accessor: "uniqueId",
  },
  {
    Header: "Date",
    accessor: "date",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Status",
    accessor: "status",
  },
 
]



const VendorTransaction = ({activeTab}) => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [dateRenge,setDateRenge] = useState({
    startDate:'',
    endDate:''
  })
  const [loading, setLoading] = useState(false);
  const [allTransactions,setAllTransactions] = useState([])
  const { id } = useParams(); 

  const [selectedPeriod, setSelectedPeriod] = useState('lastOneWeek');
  const [dateRangeText, setDateRangeText] = useState('');
  const moduleType = useSelector((state) => state.moduleType);
  const [type,setType] = useState("")
  const moduleOpt = useMemo(()=>{
    if(moduleType && moduleType?.length > 0){
      const opt = moduleType.map((item)=>{
        return {
          label:item.name,
          value: item._id,
          module:item.name
        }
      })
      return opt;
    }
    return []
  },[moduleType])

  useEffect(() => {
    const today = new Date();
    let startDate = null;
    let endDate = today;
    switch (selectedPeriod) {
      case 'lastOneWeek':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        break;
      case 'last15Days':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 14);
        break;
      case 'currentMonth':
        startDate = getFirstDayOfMonth(today);
        break;
      case 'lastMonth':
        const prevMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        startDate = getFirstDayOfMonth(prevMonthDate);
        endDate = getLastDayOfMonth(prevMonthDate);
        break;
      case 'last3Months':
        const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        startDate = getFirstDayOfMonth(threeMonthsAgo);
        break;
      case 'last6Months':
        const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);
        startDate = getFirstDayOfMonth(sixMonthsAgo);
        break;
      case 'currentFinancialYear':
        startDate = new Date(today.getFullYear(), 3, 1); 
        endDate = new Date(today.getFullYear() + 1, 2, 31); 
        break;
      case 'lastFinancialYear':
        startDate = new Date(today.getFullYear() - 1, 3, 1); 
        endDate = new Date(today.getFullYear(), 2, 31); 
        break;
      default:
        startDate = today;
        break;
    }
    if (startDate && endDate  && selectedPeriod !== 'custom' && id) {
      setDateRangeText(`${formatDate(startDate)} to ${formatDate(endDate)}`);
      fetchTransactionDetails(startDate, endDate,type,id);
    } 
    else if (dateRenge.startDate && dateRenge.endDate && selectedPeriod === 'custom' && id) {
      setDateRangeText(`${formatDate(dateRenge.startDate)} to ${formatDate(dateRenge.endDate)}`);
      startDate = dateRenge.startDate;
      endDate = dateRenge.endDate
      fetchTransactionDetails(startDate, endDate,type,id);
    } 
    else {
      setDateRangeText('');
    }
  }, [selectedPeriod,dateRenge,type,id,activeTab]);


  const fetchTransactionDetails = async (startDate,endDate,type,id) => {
      setLoading(true)
      const data = {
        startDate: startDate, 
        endDate: endDate, 
        type:type,
        vendorId:id
      }

      dispatch(fetchAsyncVendorTransactions(data))
      .then((res) => {
        if (res?.payload) {
          setAllTransactions(res?.payload)
        } else {
          addToast(`${res?.error?.message}`, { appearance: "error" });
        }
      })
      .catch((error) => {
        addToast(`Failed to fetch transaction details`, { appearance: "error" });
      }).finally(()=>{
        setLoading(false)
      });
  };


  const transactionData = useMemo(()=>{
    if(allTransactions && allTransactions?.length > 0){
      const tableData = allTransactions.map((data, index) => {
        return {
          _id: data._id,
          no: index + 1,
          poNo: <span>{data?.poNo}</span>,
          paymentId: <span>{data?.pmId}</span>,
          amount: (
            <span className={`${data?.sts === 'SUCCESS' ? 'blue' :'black'}`}>
              ₹ {data?.amt}
            </span>
          ),
          requestId: <span> {data?.reqId}</span>,
          utrNo: (<span>{data?.utr}</span>),
          uniqueId: <span className="f-600">{data?.unqId}</span>,
          date: <span>{dateFormatWithTime(data?.crAt)}</span>,
          status: (<Tag size="sm" bg={`${data?.sts === 'SUCCESS' ? 'green' :'red'}`} variant="solid">{data?.sts}</Tag>)
        };
      });
      const totalAmount = allTransactions.reduce((sum, data) => {
        return sum + (data?.amt || 0); 
      }, 0);
      return { tableData, totalAmount };    
    }
    return { tableData:[], totalAmount:0 };
  },[allTransactions])
  


  if (loading) {
    return <SpinnerLoader />;
  }


  return (
    <Box display="flex" className="mx-0 expense_details account-statement">
      <Box className="expense_details_main account-statement-list">
        <Box display="flex" justifyContent="space-between" mt={5}>

           

          <Box className="ledger-year-select">
            <CustomDropdown
              years={financialYearOptions}
              selectedYear={selectedPeriod}
              setSelectedYear={setSelectedPeriod}
              handleApply={(date) => setDateRenge(date)}
              dateRenge={dateRenge}
            />
          </Box>
          

          <Text fontWeight="600" fontSize="14px" mt={2}>
            Transaction Details ( {dateRangeText} )
          </Text>
          <div></div>
          <div></div>
        </Box>

        <Box className="acordian-box ">
          <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Transactions </Text>
                  </Box>
                  <Box flex="1" className="mx-3" display="flex"  justifyContent="flex-end" flexDirection="row">
                  <Text className="mt-1" fontWeight="400">Total Amount : <span className="creditAmount blue">₹ {formatAmountIndianRupees(transactionData?.totalAmount)}</span> </Text>
            </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {transactionData?.tableData && transactionData?.tableData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={statementColumns}
                    tableData={transactionData?.tableData}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no transaction
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default VendorTransaction;
